import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "../utils/mixpanel";

export const useTrackPageView = (pageName, properties = {}) => {
  const location = useLocation();
  const propertiesString = JSON.stringify(properties);

  useEffect(() => {
    const parsedProperties = JSON.parse(propertiesString);
    trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      ...parsedProperties,
    });
  }, [pageName, location.pathname, location.search, location.hash, propertiesString]);
};

export default useTrackPageView;
